/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Form_SubmitInputs */

const he_contact_form_submit = /** @type {(inputs: Contact_Form_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`שלח הודעה`)
};

const en_contact_form_submit = /** @type {(inputs: Contact_Form_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Send Message`)
};

/**
* | output |
* | --- |
* | "Send Message" |
*
* @param {Contact_Form_SubmitInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const contact_form_submit = /** @type {((inputs?: Contact_Form_SubmitInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Form_SubmitInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_contact_form_submit(inputs)
	return en_contact_form_submit(inputs)
});